import { OutlawCommunityConfig } from '../outlaw-community.config';
import { ConfigLink } from '../interfaces/config-link';

export function getCommunityLinks(config: Partial<OutlawCommunityConfig>): ConfigLink {
  return {
    ...config.links,
    creatorLink: config.links?.creatorLink || 'https://community-admin.maji.la',
  };
}
